/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConduitSettingsSpoolTagComponent } from './conduit-settings-spool-tag.component';
import { SysqueDropdownOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-dropdown-options-line';
import { SysqueNumberBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-number-box-options-line';
import { SysqueCheckBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-check-box-options-line';
import { SysqueLocationOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-location-options-line';

@NgModule({
  declarations: [ConduitSettingsSpoolTagComponent],
  imports: [
    CommonModule,
    FormsModule,
    SysqueDropdownOptionsLineModule,
    SysqueNumberBoxOptionsLineModule,
    SysqueCheckBoxOptionsLineModule,
    SysqueLocationOptionsLineModule
  ],
  exports: [ConduitSettingsSpoolTagComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConduitSettingsSpoolTagModule {}
